import React, { useState } from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderFour from "../common/header/HeaderFour";
import SEO from "../common/SEO";
import HireProfessionals from "../component/forrecruiters/HireProfessionals";
import GreatLearning from "../component/forrecruiters/GreatLearning";
import WorldClass from "../component/forrecruiters/WorldClass";
import ChatbotTwo from "./ChatbotTwo";

const ForRecruiters = () => {
  const [showPopup, setShowPopup] = useState(false);
  return (
    <>
      <SEO />
      <main className="main-wrapper">
        <HeaderFour />
        <div className="section section-padding">
          <HireProfessionals />
          <GreatLearning />
          <WorldClass />
          <ChatbotTwo />
        </div>
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default ForRecruiters;
